<script lang="ts" setup>
import type { ComponentBlockImageGridFragment } from "~~/types/graphql";

import { Enum_Componentblockimagegrid_Variation } from "~~/types/graphql";

const props = defineProps<{
  ImageGridMedia: ComponentBlockImageGridFragment["ImageGridMedia"];
  ImageGridVariation: Enum_Componentblockimagegrid_Variation;
}>();
</script>
<template>
  <section
    class="image-grid mx-auto grid max-w-image"
    :class="{
      'md:grid-cols-2':
        props.ImageGridVariation ===
        Enum_Componentblockimagegrid_Variation.TwoColumns,
      'grid-cols-1':
        props.ImageGridVariation ===
        Enum_Componentblockimagegrid_Variation.Full,
    }"
  >
    <div
      v-for="(image, index) in props.ImageGridMedia"
      :key="`${image?.__typename}-${index}`"
      class="max-h-screen-xl xl:max-h-screen-2xl 2xl:max-h-screen-3xl"
    >
      <base-image
        v-bind="image?.media.data[0].attributes"
        class="h-full w-full object-cover"
        :sizes="
          props.ImageGridMedia.length > 1
            ? '(min-width: 768px) 50vw, (max-width: 767px) 100vw'
            : '100vw'
        "
        :eager-loading="image.eager_loading ? true : false"
        :fetch-priority="image.fetch_priority ? true : false"
      />
    </div>
  </section>
</template>
